"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = {
            submitting: false,
            searchResults: [],
            suggestions: [],
            byPackages: false,
            showPosterPlus: false,
            showScheduleForm: false,
            showPrerequisiteForm: false
        };
        GState.bind(this, [
            'tenant',
            'user'
        ]);
        this.fhandler = new FormHandler({
            key: 'create-program',
            autosave: true
        });
        this.fhandler.bind(this);
        this.instructors = [];
    },
    onInput: function () {
        if (this.state.form.instructors)
            this.instructors = this.state.form.instructors;
    },
    onMount: function () {
        const title = 'Creating Program';
        this.fhandler.on('autosave', () => GState.activity.add({
            title,
            path: '/create-program'
        })).on('reset', () => GState.activity.remove(title));
    },
    onCall: function (...arg) {
        this.emit('call', ...arg);
    },
    onSelectPoster: function (status) {
        this.state.showPosterPlus = status || false;
    },
    onSetPoster: function ({base64, src}) {
        if (!src)
            return;
        this.fhandler.set('poster', base64 || src);
        this.state.showPosterPlus = false;
    },
    addCategory: function (categoryId, name) {
        const categories = this.state.form.categories || [];
        if (categories.length && categories.filter(each => {
                return each.categoryId == categoryId;
            }).length)
            return;
        categories.push({
            categoryId,
            name
        });
        this.fhandler.set('categories', categories);
    },
    removeCategory: function (categoryId) {
        this.fhandler.set('categories', this.state.form.categories.filter(each => {
            return each.categoryId !== categoryId;
        }));
    },
    onByPackages: function (e) {
        this.state.byPackages = e.target.checked;
        if (!e.target.checked)
            delete this.state.form.packages;
    },
    addPackage: function (type) {
        const packages = this.state.form.packages || [];
        if (packages.includes(type))
            return;
        packages.push(type);
        this.fhandler.set('packages', packages);
    },
    addAllPackage: function (packages) {
        this.fhandler.set('packages', packages);
    },
    removePackage: function (type) {
        this.fhandler.set('packages', this.state.form.packages.filter(each => {
            return each !== type;
        }));
    },
    onModalForm: function (type, status) {
        this.state['show' + type + 'Form'] = status;
    },
    removeSchedule: function (index) {
        this.fhandler.set('schedules', this.state.form.schedules.filter((each, i) => {
            return i != index;
        }));
    },
    removePrerequisite: function (index) {
        this.fhandler.set('prerequisites', this.state.form.prerequisites.filter((each, i) => {
            return i != index;
        }));
    },
    onSubmit: async function () {
        const Form = this.state.form;
        if (!Form.name)
            return this.state.formError.name = true;
        if (!Form.description)
            return this.state.formError.description = true;
        this.state.submitting = true;
        console.log(Form);
        try {
            const {error, message, programId} = await Request('/program/create', 'POST', Form);
            this.state.submitting = false;
            this.fhandler.alert(message, error ? 'error' : 'success');
            if (error)
                return;
            this.fhandler.reset();
            setTimeout(() => navigate(`/program/${ programId }/`), 3000);
        } catch (error) {
            this.state.submitting = false;
            this.fhandler.alert(error);
        }
    },
    onReset: function () {
        this.fhandler.reset();
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Programs/create/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_FormHandler = require("markojs-form"),
    FormHandler = module_FormHandler.default || module_FormHandler,
    PosterInput_template = require("../../../components/PosterInput.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    PosterInput_tag = marko_loadTag(PosterInput_template),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    Locale_template = require("../../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    SelectCategory_template = require("../../../components/SelectCategory.marko"),
    SelectCategory_tag = marko_loadTag(SelectCategory_template),
    Row_template = require("../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_styleValue = require("marko/dist/runtime/helpers/style-value"),
    Select_template = require("../../../../components/Select/index.marko"),
    Select_tag = marko_loadTag(Select_template),
    PriceInput_template = require("../../../components/PriceInput.marko"),
    PriceInput_tag = marko_loadTag(PriceInput_template),
    _preserve_tag = marko_loadTag(require("marko/dist/core-tags/components/preserve-tag")),
    SelectPackage_template = require("../../../components/SelectPackage.marko"),
    SelectPackage_tag = marko_loadTag(SelectPackage_template),
    Schedules_template = require("../../../components/Schedules.marko"),
    Schedules_tag = marko_loadTag(Schedules_template),
    WSAdapt_template = require("../../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    QuillEditor_template = require("../../../../components/QuillEditor/index.marko"),
    QuillEditor_tag = marko_loadTag(QuillEditor_template),
    Card_Accordion_template = require("../../../components/Card-Accordion/index.marko"),
    Card_Accordion_tag = marko_loadTag(Card_Accordion_template),
    Bx_template = require("../../../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    FormAlert_template = require("../../../../components/FormAlert/index.marko"),
    FormAlert_tag = marko_loadTag(FormAlert_template),
    Preloader_template = require("../../../../components/Preloader/index.marko"),
    Preloader_tag = marko_loadTag(Preloader_template),
    PrerequisiteForm_template = require("../../../components/PrerequisiteForm.marko"),
    PrerequisiteForm_tag = marko_loadTag(PrerequisiteForm_template),
    ScheduleForm_template = require("../../../components/ScheduleForm/index.marko"),
    ScheduleForm_tag = marko_loadTag(ScheduleForm_template),
    PosterPlus_template = require("../../../../components/PosterPlus/index.marko"),
    PosterPlus_tag = marko_loadTag(PosterPlus_template),
    Wrapper_Admin_template = require("../../../components/Wrapper-Admin.marko"),
    Wrapper_Admin_tag = marko_loadTag(Wrapper_Admin_template),
    marko_attrs0 = {
        "class": "row m-0"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("32c10b"),
    marko_node0 = marko_createElement("br", null, "21", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs1 = {
        "class": "form-group"
      },
    marko_attrs2 = {
        "class": "form-group"
      },
    marko_node1 = marko_createElement("br", null, "40", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs3 = {
        "class": "mb-3"
      },
    marko_attrs4 = {
        "class": "checkbox checkbox-secondary"
      },
    marko_attrs5 = {
        "for": "multi-language",
        "class": "font-medium-1"
      },
    marko_attrs6 = {
        href: "/terms"
      },
    marko_attrs7 = {
        "class": "mt-2"
      },
    marko_node2 = marko_createElement("br", null, "74", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node3 = marko_createElement("br", null, "75", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs8 = {
        "class": "col-md-4 col-12 pr-md-0 mb-md-0 mb-4"
      },
    marko_attrs9 = {
        "class": "col pl-6"
      },
    marko_attrs10 = {
        "class": "form-group"
      },
    marko_attrs11 = {
        "class": "form-group pt-2"
      },
    marko_attrs12 = {
        "class": "font-medium-2"
      },
    marko_attrs13 = {
        "class": "list-inline"
      },
    marko_attrs14 = {
        "class": "mr-2"
      },
    marko_attrs15 = {
        "class": "chip theme-bg-lighten rounded"
      },
    marko_attrs16 = {
        "class": "chip-body font-medium-2"
      },
    marko_attrs17 = {
        "class": "chip-text py-50"
      },
    marko_attrs18 = {
        "class": "chip-closeable p-50 m-50"
      },
    marko_attrs19 = {
        "class": "bx bx-x white-text"
      },
    marko_attrs20 = {
        "class": "col-md-6 col-12"
      },
    marko_attrs21 = {
        "class": "form-group"
      },
    marko_attrs22 = {
        "class": "col"
      },
    marko_attrs23 = {
        "class": "form-group"
      },
    marko_attrs24 = {
        "class": "col-md-6 col-12 form-group"
      },
    marko_attrs25 = {
        "class": "col form-group"
      },
    marko_attrs26 = {
        "class": "mb-4"
      },
    marko_attrs27 = {
        "class": "checkbox checkbox-secondary"
      },
    marko_attrs28 = {
        "for": "by-packages",
        "class": "font-medium-1"
      },
    marko_attrs29 = {
        href: "/user/subscription"
      },
    marko_node4 = marko_createElement("br", null, "63", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs30 = {
        "class": "list-inline m-0"
      },
    marko_attrs31 = {
        "class": "mr-2"
      },
    marko_attrs32 = {
        "class": "chip theme-bg-lighten rounded"
      },
    marko_attrs33 = {
        "class": "chip-body font-medium-2"
      },
    marko_attrs34 = {
        "class": "chip-text py-50"
      },
    marko_attrs35 = {
        "class": "chip-closeable p-50 m-50"
      },
    marko_attrs36 = {
        "class": "bx bx-x white-text"
      },
    marko_attrs37 = {
        "class": "col"
      },
    marko_attrs38 = {
        "class": "col text-right"
      },
    marko_attrs39 = {
        "class": "btn btn-secondary"
      },
    marko_attrs40 = {
        "class": "accordion collapse-icon accordion-icon-rotate",
        id: "program-details",
        "data-toggle-hover": "true"
      },
    marko_attrs41 = {
        "class": "mt-2"
      },
    marko_attrs42 = {
        "class": "py-1"
      },
    marko_node5 = marko_createElement("br", null, "104", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node6 = marko_createElement("br", null, "114", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node7 = marko_createElement("br", null, "115", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node8 = marko_createElement("br", null, "116", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs43 = {
        "class": "col"
      },
    marko_attrs44 = {
        "class": "col text-right"
      },
    marko_attrs45 = {
        "class": "btn btn-secondary"
      },
    marko_attrs46 = {
        "class": "pl-50"
      },
    marko_attrs47 = {
        "class": "d-inline-flex align-items-center border p-1 mr-2 mb-2",
        style: "border-radius:4px"
      },
    marko_attrs48 = {
        "class": "pl-50"
      },
    marko_attrs49 = {
        "class": "col-md-4 col-6 pr-50"
      },
    marko_attrs50 = {
        type: "reset",
        "class": "btn btn-light btn-xl w-100"
      },
    marko_attrs51 = {
        "class": "col pl-50"
      };

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_Admin_tag({
      renderBody: function(out, { themeMode }) {
        out.be("form", marko_attrs0, "@create-program", component);

        WSAdapt_tag({
            ns: "col-md-5 col-12",
            hs: "col-12",
            class: "col",
            renderBody: function(out) {
              Row_tag({
                  renderBody: function(out) {
                    out.be("div", marko_attrs8, "3", component);

                    PosterInput_tag({
                        src: state.form.poster,
                        style: "height:12rem",
                        btn: Locale("Add Poster")
                      }, out, __component, "4", [
                      [
                        "click",
                        "onSelectPoster",
                        false,
                        [
                            true
                          ]
                      ]
                    ]);

                    out.ee();

                    out.be("div", marko_attrs9, "5", component);

                    out.be("div", marko_attrs10, "6", component);

                    out.e("input", {
                        type: "text",
                        value: state.form.name,
                        name: "name",
                        "class": marko_classValue("form-control form-control-xl pl-4" + (state.formError.name != undefined ? state.formError.name ? " is-invalid" : " is-valid" : "")),
                        validate: "required",
                        placeholder: Locale("Program Name*")
                      }, "7", component, 0, 0, {
                        onchange: __component.d("change", "__onChange", false)
                      });

                    out.be("p", {
                        "class": marko_classValue("small mt-50 mb-2" + (!state.formError.name ? " d-none" : ""))
                      }, "8", component, null, 1);

                    Locale_tag({
                        text: "Program name is required"
                      }, out, __component, "9");

                    out.ee();

                    out.ee();

                    out.be("div", marko_attrs11, "10", component);

                    out.be("p", marko_attrs12, "11", component);

                    Locale_tag({
                        text: "Program Categories"
                      }, out, __component, "12");

                    out.ee();

                    out.be("ul", marko_attrs13, "13", component);

                    if (state.form.categories) {
                      marko_forOf(state.form.categories, function({ categoryId, name }, index) {
                        var $keyValue$0 = "@" + ("cat-" + index),
                            $keyScope$0 = "[" + ($keyValue$0 + "]");

                        out.e("li", marko_attrs14, $keyValue$0, component, 1)
                          .e("div", marko_attrs15, "14" + $keyScope$0, component, 1)
                            .e("div", marko_attrs16, "15" + $keyScope$0, component, 2)
                              .e("span", marko_attrs17, "16" + $keyScope$0, component, 1)
                                .t(name, component)
                              .e("div", marko_attrs18, "17" + $keyScope$0, component, 1, 0, {
                                  onclick: __component.d("click", "removeCategory", false, [
                                      categoryId
                                    ])
                                })
                                .e("i", marko_attrs19, "18" + $keyScope$0, component, 0);
                      });
                    }

                    out.be("li", null, "19", component);

                    SelectCategory_tag({
                        add: true,
                        label: "Select",
                        btnType: "btn-secondary"
                      }, out, __component, "20", [
                      [
                        "add",
                        () => navigate('/categories'),
                        false
                      ],
                      [
                        "select",
                        "addCategory",
                        false
                      ]
                    ]);

                    out.ee();

                    out.ee();

                    out.ee();

                    out.ee();
                  }
                }, out, __component, "2");

              out.n(marko_node0, component);

              Row_tag({
                  renderBody: function(out) {
                    out.be("div", marko_attrs20, "23", component);

                    out.be("div", marko_attrs21, "24", component);

                    out.e("input", {
                        type: "text",
                        value: state.form.code,
                        name: "code",
                        "class": marko_classValue("form-control form-control-xl pl-4" + (state.formError.code != undefined ? state.formError.code ? " is-invalid" : " is-valid" : "")),
                        validate: "required",
                        placeholder: Locale("Program Code")
                      }, "25", component, 0, 0, {
                        onchange: __component.d("change", "__onChange", false)
                      });

                    out.be("p", {
                        "class": marko_classValue("small mt-50 mb-2" + (!state.formError.code ? " d-none" : ""))
                      }, "26", component, null, 1);

                    Locale_tag({
                        text: "Invalid program code"
                      }, out, __component, "27");

                    out.ee();

                    out.ee();

                    out.ee();

                    out.e("div", marko_attrs22, "28", component, 1)
                      .e("div", marko_attrs23, "29", component, 1)
                        .e("input", {
                            type: "number",
                            value: state.form.points,
                            name: "points",
                            "class": marko_classValue("form-control form-control-xl pl-4" + (state.formError.points != undefined ? state.formError.points ? " is-invalid" : " is-valid" : "")),
                            placeholder: Locale("Points Eg. 100, 300")
                          }, "30", component, 0, 0, {
                            onchange: __component.d("change", "__onChange", false)
                          });
                  }
                }, out, __component, "22");

              out.e("div", marko_attrs1, "31", component, 1)
                .e("textarea", {
                    type: "text",
                    value: state.form.description,
                    name: "description",
                    "class": marko_classValue("form-control form-control-xl pl-4 " + (state.formError.description != null ? state.formError.description ? " is-invalid" : " is-valid" : "")),
                    placeholder: Locale("Description*"),
                    validate: "required",
                    style: marko_styleValue({
                        height: "100px",
                        resize: "none"
                      })
                  }, "32", component, 0, 0, {
                    onchange: __component.d("change", "__onChange", false)
                  });

              Row_tag({
                  renderBody: function(out) {
                    out.be("div", marko_attrs24, "34", component);

                    Select_tag({
                        class: "rounded",
                        size: "xl",
                        value: state.form.availability,
                        name: "availability",
                        options: [
                            {
                                value: "public",
                                label: "Public"
                              },
                            {
                                value: "private",
                                label: "Private"
                              },
                            {
                                value: "restricted",
                                label: "Restricted"
                              }
                          ],
                        placeholder: Locale("Availability*")
                      }, out, __component, "35", [
                      [
                        "select",
                        "__onChange",
                        false
                      ]
                    ]);

                    out.ee();

                    out.be("div", marko_attrs25, "36", component);

                    Select_tag({
                        class: "rounded",
                        size: "xl",
                        value: state.form.difficultyLevel,
                        name: "difficultyLevel",
                        options: [
                            {
                                value: "beginner",
                                label: "Beginner"
                              },
                            {
                                value: "intermediate",
                                label: "Intermediate"
                              },
                            {
                                value: "advanced",
                                label: "Advanced"
                              }
                          ],
                        placeholder: Locale("Difficulty Level*")
                      }, out, __component, "37", [
                      [
                        "select",
                        "__onChange",
                        false
                      ]
                    ]);

                    out.ee();
                  }
                }, out, __component, "33");

              out.be("div", marko_attrs2, "38", component);

              PriceInput_tag({
                  size: "xl",
                  name: "price",
                  value: state.form.price,
                  placeholder: Locale("Price")
                }, out, __component, "39", [
                [
                  "change",
                  "__onChange",
                  false
                ]
              ]);

              out.ee();

              out.n(marko_node1, component);

              out.be("div", marko_attrs3, "41", component);

              out.be("div", marko_attrs4, "42", component);

              _preserve_tag({
                  n: true,
                  renderBody: function(out) {
                    out.e("input", {
                        type: "checkbox",
                        id: "multi-language",
                        name: "multiLanguage",
                        checked: state.form.multiLanguage
                      }, "43", component, 0, 0, {
                        onchange: __component.d("change", "__onChecked", false)
                      });
                  }
                }, out, __component, "43");

              out.be("label", marko_attrs5, "44", component);

              Locale_tag({
                  renderBody: function(out) {
                    out.t("Multi-Language Support");
                  }
                }, out, __component, "45");

              out.t(" ");

              out.be("a", marko_attrs6, "46", component);

              Locale_tag({
                  text: "Learn more"
                }, out, __component, "47");

              out.ee();

              out.ee();

              out.ee();

              out.ee();

              if (((state.tenant.settings.pricing && state.tenant.settings.pricing) && state.tenant.settings.pricing.learner) && state.tenant.settings.pricing.learner.enabled) {
                out.be("div", marko_attrs26, "48", component);

                out.be("div", marko_attrs27, "49", component);

                _preserve_tag({
                    n: true,
                    renderBody: function(out) {
                      out.e("input", {
                          type: "checkbox",
                          id: "by-packages",
                          name: "byPackages",
                          checked: state.byPackages
                        }, "50", component, 0, 0, {
                          onchange: __component.d("change", "onByPackages", false)
                        });
                    }
                  }, out, __component, "50");

                out.be("label", marko_attrs28, "51", component);

                Locale_tag({
                    renderBody: function(out) {
                      out.t("Offer course by subscription packages");
                    }
                  }, out, __component, "52");

                out.t(" ");

                out.be("a", marko_attrs29, "53", component);

                Locale_tag({
                    text: "Learn more"
                  }, out, __component, "54");

                out.ee();

                out.ee();

                out.ee();

                out.ee();

                if (state.byPackages) {
                  out.be("ul", marko_attrs30, "55", component);

                  marko_forOf(state.form.packages, function(each, index) {
                    var $keyValue$1 = "@" + ("cat-" + index),
                        $keyScope$1 = "[" + ($keyValue$1 + "]");

                    out.e("li", marko_attrs31, $keyValue$1, component, 1)
                      .e("div", marko_attrs32, "56" + $keyScope$1, component, 1)
                        .e("div", marko_attrs33, "57" + $keyScope$1, component, 2)
                          .e("span", marko_attrs34, "58" + $keyScope$1, component, 1)
                            .t(each.toCapitalCase(), component)
                          .e("div", marko_attrs35, "59" + $keyScope$1, component, 1, 0, {
                              onclick: __component.d("click", "removePackage", false, [
                                  each
                                ])
                            })
                            .e("i", marko_attrs36, "60" + $keyScope$1, component, 0);
                  });

                  out.be("li", null, "61", component);

                  SelectPackage_tag({
                      accountType: "learner",
                      selectAll: true,
                      label: "Select Package",
                      btnType: "btn-secondary"
                    }, out, __component, "62", [
                    [
                      "select",
                      "addPackage",
                      false
                    ],
                    [
                      "select-all",
                      "addAllPackage",
                      false
                    ]
                  ]);

                  out.ee();

                  out.ee();
                }

                out.n(marko_node4, component);
              }

              out.be("div", marko_attrs7, "64", component);

              Row_tag({
                  class: "d-flex align-items-center",
                  renderBody: function(out) {
                    out.be("div", marko_attrs37, "66", component);

                    out.be("h5", null, "67", component);

                    Locale_tag({
                        text: "Schedules",
                        class: "font-medium-3"
                      }, out, __component, "68");

                    out.ee();

                    out.ee();

                    out.be("div", marko_attrs38, "69", component);

                    out.be("button", marko_attrs39, "70", component, null, 0, {
                        onclick: __component.d("click", "onModalForm", false, [
                            "Schedule",
                            true
                          ])
                      });

                    Locale_tag({
                        text: "Add"
                      }, out, __component, "71");

                    out.t("/");

                    Locale_tag({
                        text: "Edit"
                      }, out, __component, "72");

                    out.ee();

                    out.ee();
                  }
                }, out, __component, "65");

              Schedules_tag({
                  list: state.form.schedules,
                  removable: true
                }, out, __component, "73", [
                [
                  "remove",
                  "removeSchedule",
                  false
                ]
              ]);

              out.ee();

              out.n(marko_node2, component);

              out.n(marko_node3, component);
            }
          }, out, __component, "1");

        WSAdapt_tag({
            hs: "col-12",
            class: "col pt-0",
            renderBody: function(out) {
              out.be("div", marko_attrs40, "77", component);

              Card_Accordion_tag({
                  target: "program-about-content",
                  title: "Program About",
                  icon: "bx-info-circle",
                  borderStyle: true,
                  renderBody: function(out) {
                    QuillEditor_tag({
                        value: state.form.about,
                        toolbar: [
                            "list",
                            "align",
                            "embed-block",
                            "latex"
                          ],
                        name: "about",
                        height: "300px",
                        author: getFullname(state.user),
                        noReturnWordsCount: true
                      }, out, __component, "79", [
                      [
                        "change",
                        "__onChange",
                        false
                      ]
                    ]);
                  }
                }, out, __component, "78");

              Card_Accordion_tag({
                  target: "program-objectives",
                  title: "Program Objectives",
                  icon: "bx-list-check",
                  borderStyle: true,
                  renderBody: function(out) {
                    QuillEditor_tag({
                        value: state.form.objectives,
                        toolbar: [
                            "align",
                            "list"
                          ],
                        name: "objectives",
                        maxlength: 1000,
                        author: getFullname(state.user),
                        noReturnWordsCount: true
                      }, out, __component, "81", [
                      [
                        "change",
                        "__onChange",
                        false
                      ]
                    ]);
                  }
                }, out, __component, "80");

              Card_Accordion_tag({
                  target: "program-policy",
                  title: "Program Policy",
                  icon: "bx-copyright",
                  borderStyle: true,
                  renderBody: function(out) {
                    QuillEditor_tag({
                        value: state.form.policy,
                        toolbar: [
                            "align",
                            "list"
                          ],
                        name: "policy",
                        maxlength: 1000,
                        author: getFullname(state.user),
                        noReturnWordsCount: true
                      }, out, __component, "83", [
                      [
                        "change",
                        "__onChange",
                        false
                      ]
                    ]);
                  }
                }, out, __component, "82");

              Card_Accordion_tag({
                  target: "program-readings",
                  title: "Program Readings",
                  icon: "bx-book-content",
                  borderStyle: true,
                  renderBody: function(out) {
                    QuillEditor_tag({
                        value: state.form.readings,
                        name: "readings",
                        maxlength: 1000,
                        author: getFullname(state.user),
                        noReturnWordsCount: true
                      }, out, __component, "85", [
                      [
                        "change",
                        "__onChange",
                        false
                      ]
                    ]);
                  }
                }, out, __component, "84");

              out.ee();

              out.be("div", marko_attrs41, "86", component);

              Row_tag({
                  class: "d-flex align-items-center",
                  renderBody: function(out) {
                    out.be("div", marko_attrs43, "88", component);

                    out.be("h5", null, "89", component);

                    Locale_tag({
                        text: "Prerequisites",
                        class: "font-medium-3"
                      }, out, __component, "90");

                    out.ee();

                    out.ee();

                    out.be("div", marko_attrs44, "91", component);

                    out.be("button", marko_attrs45, "92", component, null, 0, {
                        onclick: __component.d("click", "onModalForm", false, [
                            "Prerequisite",
                            true
                          ])
                      });

                    Locale_tag({
                        text: "Add"
                      }, out, __component, "93");

                    out.t("/");

                    Locale_tag({
                        text: "Edit"
                      }, out, __component, "94");

                    out.ee();

                    out.ee();
                  }
                }, out, __component, "87");

              out.be("div", marko_attrs42, "95", component);

              var $for$0 = 0;

              marko_forOf(state.form.prerequisites, function({ label, link }, index) {
                var $keyScope$2 = "[" + (($for$0++) + "]");

                if (link) {
                  out.be("a", {
                      type: "button",
                      "class": "d-inline-flex align-items-center border p-1 mr-2 mb-2",
                      href: link,
                      target: "_blank",
                      style: "border-radius:4px"
                    }, "96" + $keyScope$2, component);

                  Locale_tag({
                      text: label
                    }, out, __component, "97" + $keyScope$2);

                  out.be("span", marko_attrs46, "98" + $keyScope$2, component, null, 0, {
                      onclick: __component.d("click", "removePrerequisite", false, [
                          index
                        ])
                    });

                  Bx_tag({
                      type: "x",
                      class: "p-25 round theme-bg-lighten"
                    }, out, __component, "99" + $keyScope$2);

                  out.ee();

                  out.ee();
                } else {
                  out.be("div", marko_attrs47, "100" + $keyScope$2, component);

                  Locale_tag({
                      text: label
                    }, out, __component, "101" + $keyScope$2);

                  out.be("span", marko_attrs48, "102" + $keyScope$2, component, null, 0, {
                      onclick: __component.d("click", "removePrerequisite", false, [
                          index
                        ])
                    });

                  Bx_tag({
                      type: "x",
                      class: "p-25 round theme-bg-lighten"
                    }, out, __component, "103" + $keyScope$2);

                  out.ee();

                  out.ee();
                }
              });

              out.ee();

              out.ee();

              out.n(marko_node5, component);

              FormAlert_tag({
                  alert: state.alert
                }, out, __component, "105");

              Row_tag({
                  renderBody: function(out) {
                    out.be("div", marko_attrs49, "107", component);

                    out.be("button", marko_attrs50, "108", component, null, 0, {
                        onclick: __component.d("click", "onReset", false)
                      });

                    Locale_tag({
                        text: "Reset"
                      }, out, __component, "109");

                    out.ee();

                    out.ee();

                    out.be("div", marko_attrs51, "110", component);

                    out.be("button", {
                        type: "submit",
                        "class": "btn btn-primary btn-xl w-100",
                        disabled: state.submitting
                      }, "111", component, null, 0, {
                        onclick: __component.d("click", "onSubmit", false)
                      });

                    Preloader_tag({
                        class: "float-right font-medium-5",
                        active: state.submitting
                      }, out, __component, "112");

                    Locale_tag({
                        text: "Save"
                      }, out, __component, "113");

                    out.ee();

                    out.ee();
                  }
                }, out, __component, "106");

              out.n(marko_node6, component);

              out.n(marko_node7, component);

              out.n(marko_node8, component);
            }
          }, out, __component, "76");

        out.ee();

        if (state.showPrerequisiteForm) {
          PrerequisiteForm_tag({
              for: "program",
              prerequisites: state.form.prerequisites
            }, out, __component, "117", [
            [
              "done",
              value => component.fhandler.set( 'prerequisites', value ),
              false
            ],
            [
              "dismiss",
              "onModalForm",
              false,
              [
                  "Prerequisite",
                  false
                ]
            ]
          ]);
        }

        if (state.showScheduleForm) {
          ScheduleForm_tag({
              for: "program",
              schedules: state.form.schedules
            }, out, __component, "118", [
            [
              "done",
              value => component.fhandler.set( 'schedules', value ),
              false
            ],
            [
              "dismiss",
              "onModalForm",
              false,
              [
                  "Schedule",
                  false
                ]
            ]
          ]);
        }

        if (state.showPosterPlus == true) {
          PosterPlus_tag({
              cdn: "program",
              width: 440,
              height: 280,
              maxSize: 1024,
              accepts: "image/*",
              theme: themeMode,
              adaptive: true
            }, out, __component, "119", [
            [
              "done",
              "onSetPoster",
              false
            ],
            [
              "cancelled",
              "onSelectPoster",
              false,
              [
                  false
                ]
            ]
          ]);
        }
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
